// extracted by mini-css-extract-plugin
export var contactUs = "PricingPlans-module--contactUs--22b68";
export var paragraph = "PricingPlans-module--paragraph--8bf59";
export var planRow = "PricingPlans-module--planRow--089c2";